module.exports = __webpack_public_path__ + "static/media/Работа_с_регионами_Украина.03ea73a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/Работа_с_регионами_Украина.png
// module id = 719
// module chunks = 0